import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { Check, Clock, Circle } from 'lucide-react';

const ActivationTimeline = ({ status, submittedAt, estimatedCompletion }) => {
  const formatDate = (date) => {
    return format(new Date(date), "d 'de' MMMM - HH:mm", { locale: es });
  };

  const steps = [
    {
      id: 1,
      title: 'Pago Iniciado',
      description: 'Registro y envío de información de pago',
      date: submittedAt,
      completed: true,
      active: false
    },
    {
      id: 2,
      title: 'Verificación en Proceso',
      description: 'Revisión de comprobante y validación de datos',
      date: status === 'processing' ? new Date() : null,
      completed: status === 'approved',
      active: status === 'processing'
    },
    {
      id: 3,
      title: 'Cuenta Activada',
      description: 'Acceso completo a funcionalidades de membresía',
      date: status === 'approved' ? new Date() : estimatedCompletion,
      completed: status === 'approved',
      active: false
    }
  ];

  const getStepIcon = (step) => {
    if (step?.completed) {
      return <Check className="w-5 h-5 text-white" />;
    }
    if (step?.active) {
      return <Clock className="w-5 h-5 text-white animate-pulse" />;
    }
    return <Circle className="w-5 h-5 text-muted-foreground" />;
  };

  const getStepStyles = (step) => {
    if (step?.completed) {
      return {
        iconBg: 'bg-green-600',
        line: 'bg-green-600',
        textColor: 'text-foreground'
      };
    }
    if (step?.active) {
      return {
        iconBg: 'bg-blue-600',
        line: 'bg-muted',
        textColor: 'text-foreground'
      };
    }
    return {
      iconBg: 'bg-muted',
      line: 'bg-muted',
      textColor: 'text-muted-foreground'
    };
  };

  return (
    <div className="bg-card rounded-lg border shadow-sm p-6">
      <h3 className="text-lg font-semibold text-foreground mb-6">
        Proceso de Activación
      </h3>

      <div className="space-y-6">
        {steps?.map((step, index) => {
          const styles = getStepStyles(step);
          const isLast = index === steps?.length - 1;

          return (
            <div key={step?.id} className="relative">
              <div className="flex gap-4">
                <div className="flex flex-col items-center">
                  <div className={`w-10 h-10 rounded-full ${styles?.iconBg} flex items-center justify-center`}>
                    {getStepIcon(step)}
                  </div>
                  {!isLast && (
                    <div className={`w-0.5 h-16 ${styles?.line} mt-2`} />
                  )}
                </div>

                <div className="flex-1 pb-6">
                  <h4 className={`font-semibold ${styles?.textColor} mb-1`}>
                    {step?.title}
                  </h4>
                  <p className="text-sm text-muted-foreground mb-2">
                    {step?.description}
                  </p>
                  {step?.date && (
                    <p className="text-xs text-muted-foreground flex items-center gap-1">
                      <Clock className="w-3 h-3" />
                      {step?.completed ? 'Completado: ' : 'Estimado: '}
                      {formatDate(step?.date)}
                    </p>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {status === 'rejected' && (
        <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-900">
            <strong>Verificación Rechazada:</strong> Por favor, verifica que tu comprobante de pago sea legible y contenga toda la información requerida. Si necesitas ayuda, contacta a nuestro equipo de soporte.
          </p>
        </div>
      )}
    </div>
  );
};

export default ActivationTimeline;